import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function SandySpringsProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Sandy Springs"
      headingExtra="GA"
      introText="Sandy Springs travelers — Perimeter Center corporate executives, UPS and Mercedes-Benz USA headquarters professionals, and north Fulton families — have several options for getting a passport fast. Here's how they compare, and why most Sandy Springs residents choose a registered State Department courier."
      options={options}
      emergencyDescription="Atlanta is only ~14 miles via GA-400/I-85 — literally the same metro area. But the distance is deceptive. Georgia has only ONE passport agency serving 11M+ residents statewide. GA-400 and the I-285/I-85 interchange are among the most congested corridors in the United States — during rush hour, 14 miles equals 90+ minutes. The Perimeter Center alone employs 130,000+ people, all funneling onto the same highways. A single accident on GA-400 southbound during morning rush hour adds 2+ hours with no viable alternate. When I-85 bridge fires or summer thunderstorms close the connector — which has happened multiple times — Sandy Springs is paradoxically severed from an agency in its own metro area. You can see the Atlanta skyline from your office but cannot reach the passport agency before it closes."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}